import React from 'react';

import { Typography } from 'core/cells/typography';

export const ShareNotSupportedMobile = () => {
  return <Typography>Your Mobile platform is not supported</Typography>;
};
